// src/components/DashboardLanding.jsx
// 🧭 Dashboard Landing con Grid de 9 Tarjetas EPL filtradas
import React from 'react';
import { Sparkles } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import EplLabsGrid from './EplLabsGrid';
import VertexQuickCard from './VertexQuickCard';

const DashboardLanding = ({ userName }) => {
  const { user } = useAuth();
  const hasAgents = (user?.assignedAgents?.length || 0) > 0;
  const hasEplLabs = (user?.eplSystemsAssigned?.length || 0) > 0;
  const hasAnything = hasAgents || hasEplLabs;

  return (
    <div className="p-4 md:p-6 w-full relative">
      {/* Animaciones CSS */}
      <style>{`
        @keyframes fadeInUp {
          0% {
            opacity: 0;
            transform: translateY(20px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes shimmer {
          0% { background-position: -200px 0; }
          100% { background-position: calc(200px + 100%) 0; }
        }
        
        @keyframes pulse {
          0%, 100% { transform: scale(1); opacity: 0.3; }
          50% { transform: scale(1.5); opacity: 0.7; }
        }
        
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(180deg); }
        }
        
        .shimmer-effect {
          background: linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent);
          background-size: 200px 100%;
          animation: shimmer 2s infinite;
        }
      `}</style>

      {/* 🔹 Título principal optimizado para móvil */}
      <div className="max-w-7xl mx-auto mb-4 md:mb-8 relative z-10 text-center md:text-left px-1 sm:px-0">
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 md:mb-4 transition-all duration-1000 hover:text-blue-700 leading-tight">
          Bienvenido a tu 
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600 animate-pulse">
            {" "}Laboratorio IA
          </span>
          , {userName}
        </h1>
        <p className="text-base sm:text-lg md:text-xl text-gray-600 transition-all duration-500 hover:text-gray-800 max-w-4xl mx-auto md:mx-0">
          {hasAnything
            ? 'Accede a tus simulaciones y laboratorios asignados.'
            : 'Solicita acceso a simulaciones con IA para comenzar tu entrenamiento ejecutivo.'}
        </p>
      </div>

      {/* 🔹 Separador visual antes de VRT-Coach */}
      <div className="border-t border-gray-300 my-8"></div>

      {/* 🔹 VRT-Coach - Primera sección */}
      <VertexQuickCard />

      {/* 🔹 Grid de 9 tarjetas EPL filtradas por sistemas asignados */}
      <EplLabsGrid />

      {/* 🔹 Mensaje de ayuda solo móvil */}
    </div>
  );
};

export default DashboardLanding;
